// extracted by mini-css-extract-plugin
export default {"loader":"CircularLoaderWithBackground_loader__diEpK","loader__background":"CircularLoaderWithBackground_loader__background__ZCZC9"};